import React, { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
const TOLERANCE = 0.05;
const CHILD_SIZE_RATIO = 0.8;
const FontSize = styled.div`
  height: 100%;
  width: 100%;
  font-size: ${(props) => css`
    ${props.fontSize}px
  `};
  ${(props) => props.$center ? css`
          display: flex;
          justify-content: center;
          align-items: center;
        ` : ""}
`;
const _multiplierForElement = (element, targetWidth, targetHeight) => {
  const contentWidth = element.offsetWidth;
  const contentHeight = element.offsetHeight;
  const widthMultiplier = targetWidth * CHILD_SIZE_RATIO / contentWidth;
  const heightMultiplier = targetHeight * CHILD_SIZE_RATIO / contentHeight;
  return Math.min(widthMultiplier, heightMultiplier);
};
const isValidFontSize = (fontSize) => fontSize !== 0 && Number.isFinite(fontSize);
const useAutoFontSize = (target, _container, height, width) => {
  const [fontSize, setFontSize] = useState(20);
  useEffect(() => {
    var _a;
    const container = target ? { current: { children: [target] } } : _container;
    const containerChildren = (_a = container == null ? void 0 : container.current) == null ? void 0 : _a.children;
    if (!containerChildren || containerChildren.length <= 0) {
      return;
    }
    const contentElement = containerChildren[0];
    const multiplier = _multiplierForElement(contentElement, width, height);
    if (Math.abs(1 - multiplier) <= TOLERANCE) {
      return;
    }
    const newFontSize = Math.floor(fontSize * multiplier);
    if (newFontSize !== fontSize && isValidFontSize(newFontSize)) {
      setFontSize(newFontSize);
    }
  }, [target, _container, fontSize, height, width]);
  return fontSize;
};
const AutoFontSizer = ({ children, target = null, height, width, center = false }) => {
  const _container = useRef();
  const fontSize = useAutoFontSize(target, _container, height, width);
  const _mixedContainer = _container;
  return /* @__PURE__ */ React.createElement(FontSize, { $center: center, fontSize, ref: _mixedContainer }, children);
};
export default AutoFontSizer;
